/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:7f858485-e9f4-4e8e-816f-c87eb3d9a1ba",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_ATrazg4wh",
    "aws_user_pools_web_client_id": "vebflfprfcr4f4m5iq8gncfpj",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "t4astorage580ed-dev",
    "aws_user_files_s3_bucket_region": "us-east-2",
    "aws_dynamodb_all_tables_region": "us-east-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "users-dev",
            "region": "us-east-2"
        }
    ],
    "Auth": {
        "region": "us-east-2",
        "userPoolId": "us-east-2_ATrazg4wh",
        "userPoolWebClientId": "vebflfprfcr4f4m5iq8gncfpj",
        "identityPoolId": "us-east-2:7f858485-e9f4-4e8e-816f-c87eb3d9a1ba",
        "mandatorySignIn": true,
        "authenticationFlowType": "USER_SRP_AUTH"
    }
};


export default awsmobile;
